import { stockDescReplace } from "../../../../utils/common";

// 形态列：买入/卖出信号统一显示为「看多 / 看空」胶囊
export default function ShapeBadge({ remark }) {
    const text = String(remark || "");
    const desc = stockDescReplace(text) || "";
    if (text.includes("buy")) {
        return (
            <span className="shape-up" title={desc}>
                <svg aria-hidden="true" fill="none" height="10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="10">
                    <path d="m5 15 7-7 7 7" />
                </svg>
                看多
            </span>
        );
    }
    if (text.includes("sell")) {
        return (
            <span className="shape-down" title={desc}>
                <svg aria-hidden="true" fill="none" height="10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="10">
                    <path d="m5 9 7 7 7-7" />
                </svg>
                看空
            </span>
        );
    }
    return <span className="shape-neutral" title={desc}>{desc || "—"}</span>;
}
